import { render, staticRenderFns } from "./LockFactor.vue?vue&type=template&id=2350aa50"
import script from "./LockFactor.vue?vue&type=script&lang=js"
export * from "./LockFactor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports